import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { WaveLeaderboardDropAuthor } from "./WaveLeaderboardDropAuthor";
interface WaveLeaderboardDropHeaderProps {
  readonly drop: ExtendedDrop;
}
export const WaveLeaderboardDropHeader: React.FC<WaveLeaderboardDropHeaderProps> = t0 => {
  const $ = _c(2);
  const {
    drop
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = <div className="tw-flex tw-items-center"><WaveLeaderboardDropAuthor drop={drop} /></div>;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};